<template>
    <div class="bg-fff p-20">
        <el-form label-width="200px" class="form-config">
            <el-form-item label="应用名称">
                <el-input v-model="r.app_name"></el-input>
            </el-form-item>
            <el-form-item label="域名">
                <el-input v-model="r.domain"></el-input>
            </el-form-item>
            <el-form-item label="sms_appid">
                <el-input v-model="r.sms_appid"></el-input>
            </el-form-item>
            <el-form-item label="sms_secret">
                <el-input v-model="r.sms_secret"></el-input>
            </el-form-item>
            <el-form-item label="sms_sign">
                <el-input v-model="r.sms_sign"></el-input>
            </el-form-item>
            <el-form-item label="sms_temp">
                <el-input v-model="r.sms_temp"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="_submit">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: 'config',
            r: {}
        };
    },
    created() {
        this._read();
    },
    methods: {
        _submit() {
            this.$http.post('config/save', this.r).then((res) => {
                if (res.code) {
                    this._read();
                }
            });
        },
        _read() {
            this.$http.post('config/read').then((res) => {
                this.r = res.data;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
body {
    background-color: #fff;
}
</style>